import GearConferenceIcon from './GearConferenceIcon'

export default GearConferenceIcon
